import React, { PropTypes } from 'react';
import ReactModal from 'react-modal';
import ReactSpinner from "react-spinner";
import Spinner from "./Spinner";

const styles = {
  modal: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
    },
    content: {
      backgroundColor: 'white',
      position: 'fixed',
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  },
};

const Modal = ({
  children,
  slug,
  title,
  isSaving,
  handleSave,
  isLoading,
  closeModal
}, context) => {
  const close = () => !!closeModal ? closeModal() : context.router.push(slug);

  const onRequestClose = (e) => {
    /*eslint no-restricted-globals: ["error", "event", "fdescribe"]*/
    if (!handleSave || e.keyCode === 27) {
      close();
    } else {
      if (confirm('Save before exit?')) {
        handleSave(e);
      } else {
        return ''
      }
    }
  };

  return (
    <ReactModal
      isOpen
      onRequestClose={onRequestClose}
      className="Modal"
      style={styles.modal}
      contentLabel={title}
      closeTimeoutMS={200}
      ariaHideApp={false}
    >
      <div className="modalHeader">
        <div className="modalHeaderTitle">{title}</div>
        <a className="modalHeaderClose" onClick={close}>
          <i className="fa fa-close" aria-hidden="true"></i>
        </a>
      </div>
      {isSaving && <div className='overlay-spinner'><ReactSpinner /></div>}
      <div className="modalChildren">
        {isLoading ? <Spinner /> : children}
      </div>
    </ReactModal>
  );
};

Modal.contextTypes = {
  router: PropTypes.shape().isRequired,
};

Modal.propTypes = {
  children: PropTypes.shape().isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js